<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    // Removed.by.KWShin.2024.03.08. liquidChartable.js에 이미 선언되어 있음.
    // title: String,
    value: {
      type: Array,
      required: true,
    },
  },
  computed: {
    // BEGIN::Added.by.KWShin.2024.03.29.
    title() {
      return this.$t('dv.title.dup');
    },
    // FINISH::Added.by.KWShin.2024.03.29.
  },
  watch: {
    value(data) {
      this.setData(data);
    },
  },
  data() {
    return {
      shape: 'circle',
      data: {
        value: '',
        type: 'digit',
      },
    };
  },
  methods: {
    setData(data) {
      this.data.value = data.length;
    },
  },
};
</script>
